export const formatCurrency = (
  currencyValue: number,
  currencyType: string,
  locale = 'en-US',
  showCents = true,
  isDiscount = false,
): string => {
  const value = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyType,
    minimumFractionDigits: !showCents && Number.isInteger(currencyValue) ? 0 : 2,
  }).format(currencyValue);

  return isDiscount ? `-${value}` : value;
};
